<template>
    <div>
        <van-tabs 
            v-model="activeTabIndex" 
            background="rgb(25, 29, 56)"
            color="#f9fde4"
            title-active-color="#f9fde4"
            title-inactive-color="#a4b1e8"
            swipeable
            lazy-render
            @click="activeTab"
        >
            <van-tab :key="article.id" v-for="article in articleList" :title="article.name">
                <ArticleListItem
                    v-for="item in article.article.slice(0,5)" 
                    :key="item.id" 
                    :title="item.title"
                    @click.native="handleClick(item.id)"
                ></ArticleListItem>
            </van-tab>
        </van-tabs>
        <div class="btn-more">
            <van-button 
                block
                color="#002949" 
                type="primary" 
                size="small"
                @click="viewMore"
            >查看更多</van-button>
        </div>
    </div>
</template>

<script>
import ArticleListItem from './ArticleListItem'

export default {
    data() {
        return {
            activeTabIndex: this.$store.getters.getActiveTab,
            articleList: this.$store.getters.getArticleList,
        }
    },
    components: {
        ArticleListItem
    },
    methods: {
        activeTab(index) {
            this.$store.commit('activeTab', index)
            let articleList = this.$store.getters.getArticleList
            this.$store.commit('currentCate',articleList[index].category_id)
        },
        handleClick(id){
            this.$router.push({ name: 'articleDetail', params: { id: id }});
        },
        viewMore() {
            this.$router.push('/article')
        }
    }
}
</script>

<style scoped>
.btn-more{
    padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/mjwy/home/Article.vue